import React from 'react';
import { compose } from 'recompose';
import withScreen from 'hocs/bases/withScreen';
import CustomTabs from 'components/Tabs/CustomTabs';
import { updateObject } from 'helpers/objectHelpers';

const devices = [
  { tabLabel: 'Desktop', tabValue: 'desktop' },
  { tabLabel: 'Tablet', tabValue: 'tablet' },
  { tabLabel: 'Mobile', tabValue: 'mobile' },
];

const withDevicesForm = WrappedComponent => (
  compose(withScreen())(
    ({
      screen: {
        type: screen,
      },
      onRerender = () => {},
      value = {},
      onChange,
      valueContent = {},
      onChangeContent,
      valueSettings = {},
      onChangeSettings,
      valueStyles = {},
      onChangeStyles,
      refElement = '',
      ...props,
    }) => {
      return (
        <CustomTabs onTouchTab={onRerender} defaultTabValue={screen}>
          {devices.map(({ tabLabel, tabValue }) => (
            <WrappedComponent
              key={tabValue}
              style={{ marginTop: 10, marginLeft: 10 }}
              tabLabel={tabLabel} // for tabs
              tabValue={tabValue} // for tabs
              onRerender={onRerender}
              value={value[tabValue] || {}}
              onChange={val => {
                return onChange(updateObject(value, { [tabValue]: val }))
              }}
              valueContent={valueContent[tabValue] || {}}
              onChangeContent={val => onChangeContent(updateObject(valueContent, { [tabValue]: val }))}
              valueSettings={valueSettings[tabValue] || {}}
              onChangeSettings={val => (
                onChangeSettings(updateObject(valueSettings, { [tabValue]: val }))
              )}
              valueStyles={valueStyles[tabValue] || {}}
              onChangeStyles={val => onChangeStyles(updateObject(valueStyles, { [tabValue]: val }))}
              refElement={refElement}
              {...props}
            />
          ))}
        </CustomTabs>
      )
    },
  )
);

export default withDevicesForm;



// WEBPACK FOOTER //
// ./src/hocs/extends/withDevicesForm.js